/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseShowroomDetailsFragment} from '@amblique/contentful/app/contentful/fragments/showroom-details/base-showroom-details.fragment';
import {BaseActionLinksFragment} from '@amblique/contentful/app/contentful/fragments/action-links/base-action-links.fragment';
import {BaseHeroBannerFragment} from '@amblique/contentful/app/contentful/fragments/hero-banner/base-hero-banner.fragment';
import {BaseIconFragment} from '@amblique/contentful/app/contentful/fragments/icon/base-icon.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';
import {BaseLinkFragment} from '@amblique/contentful/app/contentful/fragments/link/base-link.fragment';
import {BaseSeoFragment} from '@amblique/contentful/app/contentful/fragments/seo/base-seo.fragment';

export const ShowroomDetailsFragment = gql`
  ${BaseActionLinksFragment}
  ${BaseHeroBannerFragment}
  ${BaseIconFragment}
  ${BaseImageFragment}
  ${BaseLinkFragment}
  ${BaseSeoFragment}
  ${BaseShowroomDetailsFragment}

  fragment ShowroomDetailsFragment on ShowroomDetails {
    ...BaseShowroomDetailsFragment

    countries {
      ...BaseActionLinksFragment
    }
    featuredImage {
      ...BaseImageFragment
    }
    headerBlock {
      ...BaseHeroBannerFragment
    }
    onDisplayCollection {
      items {
        __typename
        ... on Icon {
          ...BaseIconFragment
        }
      }
    }
    onDisplayCursorCollection {
      items {
        __typename
        ... on Icon {
          ...BaseIconFragment
        }
      }
    }
    relatedPages {
      ...BaseActionLinksFragment
    }
    seo {
      ...BaseSeoFragment
    }
    storeImages {
      ...BaseLinkFragment
    }
  }
`;
